import { IdosInInstanceCount } from 'src/models/idoList';

import { Callback } from 'src/util/query/models/Callback';

import { IdoListCallbackStoreContract } from '../interfaces';

export class GetTheIdoListviewIdosInInstanceCountQueryCallBack extends Callback<IdosInInstanceCount[]> {
	public constructor(private readonly store: IdoListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: IdosInInstanceCount[]): void => {
		this.store.setIdosInInstanceCountList(successResponse);
	};
}
